import React from 'react';
import { Paper, TextField } from '@material-ui/core';

class SearchBar extends React.Component{
    state ={
        searchTerm:'',
    }

handleChange = (event) => this.setState({searchTerm: event.target.value});
    
handleSubmit = (event) =>{
    const {serachTerm} = this.state;
    const {onFromSubmit} = this.props;

    onFromSubmit(serachTerm);

    event.preventDefault();
}

    render(){
        return(
            <Paper elevation={6} style={{padding: '25px'}}>
                <form onSubmit={this.handleSubmit}>
                    <TextField fullWidth label="Serach...." onChange={this.handleChange}/>
                </form>
            </Paper>
        )
    }
}

export default SearchBar;